import React from 'react';
import { Button, AddOutlined, Text } from '@landr/maestro';
import { Trans } from '@lingui/macro';
import { RouterLink } from 'components/CommonUi/RouterLink';
import { useCreatorFooter } from './CreatorFooter.helpers';
import Styled from './CreatorFooter.styled';

const CreatorFooter: React.FC = () => {
    const {
        browseLoop,
        showCreatorFooter,
        handleAddSampleClick,
        handleFreeSamplesClick,
        freeSamplesLoop,
    } = useCreatorFooter();

    if (!showCreatorFooter) {
        return null;
    }

    return (
        <Styled.Section>
            <Button
                as={RouterLink}
                isRounded
                icon={AddOutlined}
                onClick={handleAddSampleClick}
                variant="subtle"
                to={browseLoop}
            >
                <Trans>Add a sample</Trans>
            </Button>
            <Styled.TextWrapper>
                <Text contrast={'low'} size="sm">
                    <Trans>Give your beat depth by adding more loops.</Trans>
                </Text>
                <Button
                    as={Styled.LinkContainer}
                    kind="link"
                    variant="secondary"
                    to={freeSamplesLoop}
                    onClick={handleFreeSamplesClick}
                >
                    <Trans>Browse free samples here.</Trans>
                </Button>
            </Styled.TextWrapper>
        </Styled.Section>
    );
};

export default CreatorFooter;
